import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLTableStyling = () => {
  return (
    <div className="html-container">
      <h1>HTML Tables – Table Styling</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          HTML tables can be styled using CSS to improve readability and presentation. Styling includes borders, spacing, colors, fonts, and hover effects.
        </p>
      </section>

      {/* 2. Adding Borders */}
      <section id="borders">
        <h2>2. Adding Borders</h2>
        <p>You can style table borders using CSS instead of the old <code>border</code> attribute:</p>
        <pre>
          <code>{`<table class="styled-table">
  <tr>
    <th>Name</th>
    <th>Age</th>
    <th>City</th>
  </tr>
  <tr>
    <td>John Doe</td>
    <td>25</td>
    <td>New York</td>
  </tr>
  <tr>
    <td>Jane Smith</td>
    <td>30</td>
    <td>London</td>
  </tr>
</table>`}</code>
        </pre>
        <p>CSS for borders:</p>
        <pre>
          <code>{`.styled-table {
  border-collapse: collapse;
  width: 100%;
}

.styled-table th, .styled-table td {
  border: 1px solid #333;
  padding: 10px;
}

.styled-table th {
  background-color: #007bff;
  color: white;
}`}</code>
        </pre>
      </section>

      {/* 3. Table Row Styling */}
      <section id="row-styling">
        <h2>3. Table Row Styling</h2>
        <p>Alternate row colors improve readability:</p>
        <pre>
          <code>{`.styled-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.styled-table tr:hover {
  background-color: #e0f7fa;
}`}</code>
        </pre>
      </section>

      {/* 4. Column Styling */}
      <section id="column-styling">
        <h2>4. Column Styling</h2>
        <p>You can target specific columns using <code>:nth-child()</code>:</p>
        <pre>
          <code>{`.styled-table td:nth-child(2) {
  text-align: center;
  font-weight: bold;
}`}</code>
        </pre>
      </section>

      {/* 5. Table Caption */}
      <section id="caption">
        <h2>5. Table Caption</h2>
        <p>Add a caption to describe the table:</p>
        <pre>
          <code>{`<table class="styled-table">
  <caption>Student Scores</caption>
  <tr>
    <th>Name</th>
    <th>Score</th>
  </tr>
  <tr>
    <td>John Doe</td>
    <td>95</td>
  </tr>
</table>`}</code>
        </pre>
        <p>CSS for caption:</p>
        <pre>
          <code>{`.styled-table caption {
  caption-side: top;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 10px;
}`}</code>
        </pre>
      </section>

      {/* 6. Best Practices */}
      <section id="best-practices">
        <h2>6. Best Practices</h2>
        <ul>
          <li>Use <code>border-collapse: collapse</code> for clean borders.</li>
          <li>Alternate row colors for readability.</li>
          <li>Use <code>nth-child</code> for column-specific styling.</li>
          <li>Add captions for context.</li>
          <li>Use CSS classes instead of inline attributes for maintainability.</li>
        </ul>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>CSS allows complete control over table borders, spacing, and colors.</li>
          <li>Row and column styling improves readability.</li>
          <li>Hover effects can highlight rows or cells.</li>
          <li>Captions provide context and improve accessibility.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLTableStyling;
